import { render, staticRenderFns } from "./veStuScholarshipEdit.vue?vue&type=template&id=6269633e&scoped=true"
import script from "./veStuScholarshipEdit.vue?vue&type=script&lang=js"
export * from "./veStuScholarshipEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6269633e",
  null
  
)

export default component.exports